module.exports = __webpack_public_path__ + "f4f577b11a9d85dec4145a2bcc1a9b0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-doya.png
// module id = 2088
// module chunks = 4